import {Clapperboard, Package, UserRound} from '@nlabs/gothamjs/icons';

import type {ReactElement} from 'react';

const uses = [
  {icon: Package, label: 'Products'},
  {icon: UserRound, label: 'Characters'},
  {icon: Clapperboard, label: 'Stories'}
];

export const MonthlyBalanceVisual = (): ReactElement => (
  <>
    <div className="mb-3 flex items-center justify-between text-[9px] leading-3 tracking-[.14em] text-white/55"><span>MONTHLY BALANCE</span><span className="tracking-normal text-violet-300">Example</span></div>
    <div className="flex items-center gap-5">
      <div className="flex size-28 shrink-0 items-center justify-center rounded-full bg-[conic-gradient(#b9a0ff_0%_70%,#362d49_70%_100%)] p-2">
        <div className="flex size-full flex-col items-center justify-center rounded-full bg-[#15101f]"><span className="text-3xl leading-9 font-medium text-violet-100 tabular-nums">$21</span><span className="mt-1 text-[9px] leading-3 text-white/60">Available</span></div>
      </div>
      <div className="space-y-4">
        <div><p className="text-[9px] leading-3 text-white/55">Monthly allowance</p><p className="mt-1 text-lg leading-6 text-white/90 tabular-nums">$30</p></div>
        <div><p className="text-[9px] leading-3 text-white/55">Used so far</p><p className="mt-1 text-lg leading-6 text-violet-300 tabular-nums">$9</p></div>
      </div>
    </div>
    <div className="mt-3 border-t border-white/10 pt-3">
      <p className="text-[9px] leading-3 text-white/60">One allowance, across your next shots.</p>
      <div className="mt-2 grid grid-cols-3 gap-1.5">{uses.map(({icon: Icon, label}) => <span className="flex items-center justify-center gap-1.5 rounded-md bg-violet-300/10 py-1.5 text-[8px] leading-3 text-violet-100" key={label}><Icon size={11} />{label}</span>)}</div>
    </div>
  </>
);
